import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { FintechIndustryPage } from "@/components/site/FintechIndustryPage";
import { FINTECH_META_DESCRIPTION } from "@/content/meta/FintechIndustryPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/industries/fintech")({
  head: () => ({
    meta: [
      { title: "Fintech Media Monitoring & Analysis | Perceptica" },
      { name: "description", content: FINTECH_META_DESCRIPTION },
      { property: "og:title", content: "Fintech Media Monitoring & Analysis | Perceptica" },
      { property: "og:description", content: FINTECH_META_DESCRIPTION },
      { name: "twitter:title", content: "Fintech Media Monitoring & Analysis | Perceptica" },
      { name: "twitter:description", content: FINTECH_META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://perceptica.com/industries/fintech" },
      ...ogImageMeta("en", "/industries/fintech"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/industries/fintech" }),
  }),
  component: FintechIndustryPage,
});
